import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ApiService } from 'src/services/apiService';

@Component({
  selector: 'app-revenue-report',
  standalone: true,
  imports: [FormsModule,CommonModule,ProgressSpinnerModule],
  templateUrl: './revenue-report.component.html',
  styleUrl: './revenue-report.component.css'
})
export class RevenueReportComponent {

  fromDate:string|undefined;
  toDate:string|undefined;
  isLoading=false;

  reportList:any[]=[];


  constructor(private apiService:ApiService){

  }

  getData(){

    this.isLoading=true;

    var body={
      "fromDate":  this.fromDate,
      "toDate": this.toDate
    };

    var request= this.apiService.post("moin/RevenueReport",body);

    request.subscribe(response=>{

      this.isLoading=false;

      this.reportList=response.data as any[];
      
    });


  }



}
